module.exports = __webpack_public_path__ + "static/media/IMG_8745.75ac7d7f.JPG";